import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import "./index.css";
import { doSMS } from "../../../../functions/Twilio";
import HexHover from "../../../../components/HexHover";
import VerificationChat from "../VerificationChat";

const VerificationModal = ({
  hex,
  logo,
  icon,
  smsSender,
  brand_data,
  onSuccess = () => {},
  modalNumber,
}) => {
  const closeBtn = useRef();

  return (
    <div
      className="modal fade"
      id="phone_verification_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Phone Number Verification</h5>
            <button
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={closeBtn}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <VerificationChat
              hex={hex}
              logo={logo}
              icon={icon}
              smsSender={smsSender}
              brand_data={brand_data}
              modalNumber={modalNumber}
              onSuccess={(phoneNumber, avatar_url) => {
                onSuccess(phoneNumber, avatar_url);
                closeBtn.current.click();
              }}
              onClose={() => {
                closeBtn.current.click();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationModal;



// WEBPACK FOOTER //
// ./src/screens/Profile/components/VerificationModal/index.jsx